import XHR_API from "./xhrNetwork";
import FETCH_API from "./fetch";
import AXIOS_API from "./axiosapi";

export default class ApiRequest {

  /**
   * The constructor function is called when the class is instantiated.
   */
  constructor() {
    this.fetchApi = new FETCH_API();
    this.axiosApi = new AXIOS_API();
    this.xhrApi = new XHR_API();
  }

  /**
   * If the browser supports the fetch API, use it, otherwise use the axios API, otherwise use the xhr
   * API.
   * @param url - The url to make the request to.
   * @returns A promise.
   */
  getRequest(url) {
    let networkServiceOrder = ["fetch", "axios", "xhr"];
    let response = "";
    if (window.fetch && typeof window.fetch === "function") {
      response = this.fetchApi.getRequest(url);
    } else if (window.axios && typeof window.axios === "function") {
      response = this.axiosApi.getRequest(url);
    } else {
      response = this.xhrApi.getRequest(url);
    }
    return response;
  }

  /**
   * If the browser supports fetch, use fetch, otherwise use axios, otherwise use xhr
   * @param url - The url to which the request is to be made.
   * @param payload - The data to be sent to the server.
   * @returns The response from the API call.
   */
  postRequest(url, payload) {
    let response;
    if (window.fetch && typeof window.fetch === "function") {
      response = this.fetchApi.postRequest(url, payload);
    } else if (window.axios && typeof window.axios === "function") {
      response = this.axiosApi.postRequest(url, payload);
    } else {
      response = this.xhrApi.postRequest(url, payload);
    }
    return response;
  }
}
